/**
 * plennia-subscription.js — Quiz & results subscription layer
 * ─────────────────────────────────────────────────────────────
 * Adds to every .plennia-plan-product-card:
 *   · One-time / Subscribe & Save radio toggle
 *   · Hidden Subscribe & Save button (wired to Shopify Cart API with selling_plan)
 *   · Subscription price block showing discounted price
 * Appends a "Never run out" banner below .plennia-plan-results-products__slots.
 * Loaded AFTER plennia-plan-quiz.js (deferred). No changes to main bundle required.
 *
 * ACTIVATION: once a selling plan app is installed, inject:
 *   window.PlenniaSubscriptionConfig = { defaultSellingPlanId: '1234567890', discountPct: 10 };
 * before this file loads (e.g. from PlenniaThemeConfig in theme.liquid).
 * Without a selling plan ID the toggle still renders, subscribe button is hidden,
 * and a "coming soon" teaser appears instead.
 */
(function () {
  'use strict';

  var CFG = {
    discountPct: 10,
    subscribeLabel: 'Subscribe & Save',
    onceLabel: 'One-time',
    get defaultSellingPlanId() {
      return (window.PlenniaSubscriptionConfig && window.PlenniaSubscriptionConfig.defaultSellingPlanId) || null;
    },
    get discountPctEffective() {
      return (window.PlenniaSubscriptionConfig && window.PlenniaSubscriptionConfig.discountPct) || this.discountPct;
    },
  };

  function addToCart(items) {
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    var endpoint = url.endsWith('.js') ? url : url + '.js';
    return fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    }).then(function (res) {
      if (!res.ok) throw new Error('Cart add failed');
      return res.json();
    });
  }

  function openCart() {
    window.location.href = (window.routes && window.routes.cart_url) || '/cart';
  }

  function fmtMoney(cents) {
    var amount = (Number(cents) / 100).toFixed(2);
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '€';
    return cur + amount;
  }

  /* ── Enhance a single product card ───────────────────── */
  function enhanceCard(card) {
    if (card.dataset.subEnhanced) return;
    card.dataset.subEnhanced = 'true';

    var addBtn = card.querySelector('[data-plennia-add-item]');
    var variantId = addBtn && addBtn.dataset.variantId;
    if (!variantId) return;

    var sellingPlanId = card.dataset.sellingPlanId || CFG.defaultSellingPlanId;
    var discountPct = Number(card.dataset.subscriptionDiscount || CFG.discountPctEffective);

    var priceEl = card.querySelector('.plennia-plan-product-card__price');
    var rawText = priceEl ? priceEl.textContent.replace(/[^0-9.,]/g, '').replace(',', '.') : '0';
    var basePrice = Math.round(parseFloat(rawText) * 100);
    var subPrice = basePrice ? Math.round(basePrice * (1 - discountPct / 100)) : 0;

    var body = card.querySelector('.plennia-plan-product-card__body');
    if (!body) return;

    var cardId = 'sub-' + variantId + '-' + Math.random().toString(36).slice(2, 7);
    card.dataset.subCardId = cardId;

    // --- Purchase-type toggle ---
    var toggle = document.createElement('div');
    toggle.className = 'plennia-plan-product-card__purchase-type';
    toggle.dataset.purchaseToggle = cardId;
    toggle.innerHTML =
      '<label class="plennia-plan-product-card__type-option plennia-plan-product-card__type-option--active">' +
        '<input type="radio" name="purchase-type-' + cardId + '" value="once" checked>' +
        '<span class="plennia-plan-product-card__type-label">' + CFG.onceLabel + '</span>' +
      '</label>' +
      '<label class="plennia-plan-product-card__type-option">' +
        '<input type="radio" name="purchase-type-' + cardId + '" value="subscribe">' +
        '<span class="plennia-plan-product-card__type-label">' + CFG.subscribeLabel +
          ' <em class="plennia-plan-product-card__save-pill">Save ' + discountPct + '%</em>' +
        '</span>' +
      '</label>';

    // --- Subscription price block (hidden by default) ---
    var subPriceEl = document.createElement('div');
    subPriceEl.className = 'plennia-plan-product-card__price plennia-plan-product-card__price--sub';
    subPriceEl.dataset.priceSubscribe = cardId;
    subPriceEl.hidden = true;
    subPriceEl.innerHTML = subPrice
      ? '<s class="plennia-plan-product-card__compare">' + fmtMoney(basePrice) + '</s>' +
        '<span class="plennia-plan-product-card__sub-price">' + fmtMoney(subPrice) + '</span>' +
        '<span class="plennia-plan-product-card__save-badge">–' + discountPct + '%</span>'
      : '<span class="plennia-plan-product-card__sub-price">Subscribe &amp; Save ' + discountPct + '%</span>';

    if (priceEl) {
      priceEl.dataset.priceOnce = cardId;
      body.insertBefore(toggle, priceEl);
      priceEl.after(subPriceEl);
    } else {
      var act = body.querySelector('.plennia-plan-product-card__actions');
      if (act) body.insertBefore(toggle, act);
    }

    // --- Subscribe button or coming-soon teaser ---
    var actionsEl = card.querySelector('.plennia-plan-product-card__actions');
    if (actionsEl) {
      if (sellingPlanId) {
        var subBtn = document.createElement('button');
        subBtn.className = 'button plennia-plan-product-card__btn-subscribe';
        subBtn.type = 'button';
        subBtn.setAttribute('data-plennia-subscribe-item', '');
        subBtn.dataset.variantId = variantId;
        subBtn.dataset.sellingPlanId = sellingPlanId;
        subBtn.dataset.subCardId = cardId;
        subBtn.hidden = true;
        subBtn.textContent = CFG.subscribeLabel + ' –' + discountPct + '%';
        var onceBtn = actionsEl.querySelector('[data-plennia-add-item]');
        if (onceBtn) onceBtn.after(subBtn);
        else actionsEl.prepend(subBtn);
      } else {
        var teaser = document.createElement('div');
        teaser.className = 'plennia-plan-product-card__sub-teaser';
        teaser.innerHTML =
          '<svg class="plennia-plan-product-card__sub-icon" width="12" height="12" viewBox="0 0 24 24"' +
          ' fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
          '<path d="M21.5 2v6h-6"/><path d="M2.5 22v-6h6"/>' +
          '<path d="M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2"/></svg> ' +
          'Subscribe &amp; Save — coming soon';
        actionsEl.append(teaser);
      }
    }

    // --- Radio toggle listener ---
    toggle.addEventListener('change', function (e) {
      if (e.target.type !== 'radio') return;
      applyMode(card, cardId, e.target.value);
    });
  }

  function applyMode(card, cardId, mode) {
    var priceOnce = card.querySelector('[data-price-once="' + cardId + '"]');
    var priceSub  = card.querySelector('[data-price-subscribe="' + cardId + '"]');
    var btnOnce   = card.querySelector('[data-plennia-add-item]');
    var btnSub    = card.querySelector('[data-plennia-subscribe-item]');
    if (priceOnce) priceOnce.hidden = mode === 'subscribe';
    if (priceSub)  priceSub.hidden  = mode === 'once';
    if (btnOnce)   btnOnce.hidden   = mode === 'subscribe';
    if (btnSub)    btnSub.hidden    = mode === 'once';
    card.querySelectorAll('.plennia-plan-product-card__type-option').forEach(function (label) {
      var inp = label.querySelector('input');
      label.classList.toggle('plennia-plan-product-card__type-option--active', inp && inp.value === mode);
    });
  }

  /* ── Never-run-out subscription banner ───────────────── */
  function injectBanner(container, petName) {
    if (container.querySelector('.plennia-plan-results-sub')) return;
    var name     = petName || 'your pet';
    var nameCap  = name.charAt(0).toUpperCase() + name.slice(1);
    var discount = CFG.discountPctEffective;

    var subItems = [];
    container.querySelectorAll('[data-plennia-subscribe-item]').forEach(function (btn) {
      var vid  = Number(btn.dataset.variantId);
      var spid = btn.dataset.sellingPlanId;
      if (vid && spid) subItems.push({ id: vid, quantity: 1, selling_plan: Number(spid) || spid });
    });
    var live = subItems.length > 0;

    var ctaHtml = live
      ? '<button class="plennia-plan-results-sub__cta" type="button" data-subscribe-all data-items=\'' +
          JSON.stringify(subItems) + '\'>Subscribe &amp; Save ' + discount + '% — deliver monthly</button>'
      : '<p class="plennia-plan-results-sub__coming">' +
          '<span class="plennia-badge plennia-badge--muted">Coming soon</span> ' +
          'Subscriptions launching soon — your plan is saved and ready.</p>';

    var banner = document.createElement('section');
    banner.className = 'plennia-plan-results-sub';
    banner.innerHTML =
      '<div class="plennia-plan-results-sub__inner">' +
        '<div class="plennia-plan-results-sub__eyebrow">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
          '<path d="M21.5 2v6h-6"/><path d="M2.5 22v-6h6"/>' +
          '<path d="M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2"/></svg> Plennia Plan' +
        '</div>' +
        '<h3 class="plennia-plan-results-sub__title">Never run out for ' + nameCap + '</h3>' +
        '<p class="plennia-plan-results-sub__body">Subscribe to your recommended plan and save ' + discount + '% on every delivery, automatically timed to your pet&#39;s monthly needs.</p>' +
        '<ul class="plennia-plan-results-sub__perks">' +
          '<li><span class="plennia-plan-results-sub__perk-check">✓</span> ' + discount + '% off every order</li>' +
          '<li><span class="plennia-plan-results-sub__perk-check">✓</span> Free delivery</li>' +
          '<li><span class="plennia-plan-results-sub__perk-check">✓</span> Pause or cancel anytime</li>' +
          '<li><span class="plennia-plan-results-sub__perk-check">✓</span> Adjust quantities each month</li>' +
        '</ul>' +
        ctaHtml +
      '</div>';
    container.append(banner);

    var ctaBtn = banner.querySelector('[data-subscribe-all]');
    if (ctaBtn) {
      ctaBtn.addEventListener('click', function () {
        var items = JSON.parse(ctaBtn.dataset.items || '[]');
        if (!items.length) return;
        ctaBtn.disabled = true;
        ctaBtn.textContent = 'Adding to cart…';
        addToCart(items).then(openCart).catch(function () {
          ctaBtn.disabled = false;
          ctaBtn.textContent = 'Subscribe & Save ' + discount + '% — deliver monthly';
        });
      });
    }
  }

  /* ── Subscribe-item click (event delegation) ─────────── */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-plennia-subscribe-item]');
    if (!btn || btn.disabled) return;
    event.preventDefault();
    var vid  = Number(btn.dataset.variantId);
    var spid = btn.dataset.sellingPlanId;
    if (!vid) return;
    var item = { id: vid, quantity: 1 };
    if (spid) item.selling_plan = Number(spid) || spid;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    addToCart([item])
      .then(function () { btn.textContent = 'Subscribed ✓'; })
      .catch(function () { btn.disabled = false; btn.textContent = CFG.subscribeLabel; });
  });

  /* ── MutationObserver: watch for cards + slot containers ─ */
  function scanCards(root) {
    root.querySelectorAll('.plennia-plan-product-card:not([data-sub-enhanced])').forEach(enhanceCard);
  }

  function scanContainers(root) {
    root.querySelectorAll('.plennia-plan-results-products__slots').forEach(function (slots) {
      var container = slots.closest(
        '[data-recommendation-results], .plennia-plan-results-products, plennia-recommendations, plennia-plan-results-products'
      );
      if (!container || container.dataset.subBannerInjected) return;
      container.dataset.subBannerInjected = 'true';
      var nameEl  = container.closest('[data-pet-name]');
      var petName = nameEl ? nameEl.dataset.petName : '';
      setTimeout(function () { injectBanner(container, petName); }, 80);
    });
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        scanCards(node);
        scanContainers(node);
        if (node.matches && node.matches('.plennia-plan-product-card')) enhanceCard(node);
      });
    });
  });

  function init() {
    observer.observe(document.body, { childList: true, subtree: true });
    scanCards(document);
    scanContainers(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
